<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">Perform each of the unit conversions shown below:</p>
      <div v-for="question in questions" :key="question.inputName">
        <p class="mb-2">
          {{ question.textPreQuantity }}
          <number-value :value="getNumberValue(question.number)" />
          <stemble-latex :content="question.textPostQuantity" />
        </p>
        <calculation-input
          v-model="inputs[question.inputName]"
          :disabled="!allowEditing"
          class="mb-4"
          :append-text="question.toUnits"
          outlined
        />
      </div>
      <p class="mb-4">
        g) In 2 or 3 sentences, explain how you convert quantities from one unit to another in the
        examples above.
      </p>
      <div>
        <s-textarea v-model="inputs.explainedResponse" class="mb-4" outlined />
      </div>
    </v-form>
    <ai-loading-overlay v-if="isSubmitting" />
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import StembleLatex from '@/tasks/components/StembleLatex';
import NumberValue from '../NumberValue';
import STextarea from '@/common/components/STextarea.vue';
import AiLoadingOverlay from '@/tasks/components/AiLoadingOverlay.vue';

export default {
  name: 'DetermineSimpleUnitConversions1',
  components: {
    AiLoadingOverlay,
    STextarea,
    StembleLatex,
    CalculationInput,
    NumberValue,
  },
  mixins: [DynamicQuestionMixin()],
  props: {
    isSubmitting: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      inputs: {
        input1: null,
        input2: null,
        input3: null,
        input4: null,
        input5: null,
        input6: null,
        explainedResponse: null,
      },
      questions: [
        {
          textPreQuantity: 'a) ',
          textPostQuantity: '$\\ce{mg}$ to $\\ce{g}$',
          toUnits: '$\\ce{g}$',
          number: 'number1',
          inputName: 'input1',
        },
        {
          textPreQuantity: 'b) ',
          textPostQuantity: '$\\ce{m}$ to $\\ce{pm}$',
          toUnits: '$\\ce{pm}$',
          number: 'number2',
          inputName: 'input2',
        },
        {
          textPreQuantity: 'c) ',
          textPostQuantity: '$\\text{mm to }\\mu\\text{m}$',
          toUnits: '$\\ce{\\mu m}$',
          number: 'number3',
          inputName: 'input3',
        },
        {
          textPreQuantity: 'd) ',
          textPostQuantity: '$\\ce{g}$ to $\\ce{kg}$',
          toUnits: '$\\ce{kg}$',
          number: 'number4',
          inputName: 'input4',
        },
        {
          textPreQuantity: 'e) ',
          textPostQuantity: '$\\ce{mm}$ to $\\ce{nm}$',
          toUnits: '$\\ce{nm}$',
          number: 'number5',
          inputName: 'input5',
        },
        {
          textPreQuantity: 'f) ',
          textPostQuantity: '$\\ce{s}$ to $\\ce{ms}$',
          toUnits: '$\\ce{ms}$',
          number: 'number6',
          inputName: 'input6',
        },
      ],
    };
  },
  computed: {
    number1() {
      return this.taskState.getValueBySymbol('number1').content;
    },
    number2() {
      return this.taskState.getValueBySymbol('number2').content;
    },
    number3() {
      return this.taskState.getValueBySymbol('number3').content;
    },
    number4() {
      return this.taskState.getValueBySymbol('number4').content;
    },
    number5() {
      return this.taskState.getValueBySymbol('number5').content;
    },
    number6() {
      return this.taskState.getValueBySymbol('number6').content;
    },
  },
  methods: {
    getNumberValue(numberPropertyName) {
      // Access the computed property based on the provided numberPropertyName
      return this[numberPropertyName];
    },
  },
};
</script>
